<template>
  <router-link :to="{ name: 'dashboard' }">
    <div class="logo" v-bind:class="[{ collapsed: collapsed }]">
      <img src="~@/assets/logo.png" alt="logo" class="img-header-collapsed-logo" />
      <span class="span-logo">K</span>
      <span class="span-logo after">gms</span>

      <!-- <img src="../../../../kgms-ui/public/kaimadata_logo.png" alt="logo" /> -->
      <!-- <img class="img-header-logo" src="~@/assets/SmartVP_log2w.png" alt="logo" /> -->
      <!-- <img class="img-header-logo img-header-logo-dark" src="~@/assets/SmartVP_log3w.png" alt="logo" /> -->
      <!-- <img class="img-header-logo" src="~@/assets/SmartVP_logo2.png" alt="logo" /> -->
      <!-- <img class="img-header-logo img-header-logo-light" src="~@/assets/SmartVP_logo3.png" alt="logo" /> -->
      <!-- <img class="img-header-logo" src="~@/assets/SmartVP_logo4.png" alt="logo" /> -->
      <h1 v-if="collapsed === false">{{ title }}</h1>
    </div>
  </router-link>
</template>

<script>
import { mixin } from '@/utils/mixin.js'

export default {
  name: 'Logo',
  mixins: [mixin],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    collapsed: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
<style lang="less" scoped>
.sider {
  box-shadow: none !important;
  .logo {
    height: 51px !important;
    line-height: 51px !important;
    box-shadow: none !important;
    // transition: background 300ms;

    a {
      color: white;
      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  .logo:not(.collapsed) {
    // background-image: url(~@/assets/kaimadata_logo.png);
    background-size: 134px;
    background-repeat: no-repeat;
    background-position: 23px 5px;
  }
}

[show-title='true'] .logo {
  width: 200px;
  // background-image: url(~@/assets/kaimadata_logo.png);
  background-size: 134px;
  background-repeat: no-repeat;
  background-position: 27px 5px;
}

// .mobile .logo.collapsed img,
// [show-title='true'] img {
//   display: none;
// }
</style>
